import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { useLabel } from '@atlas/core';
import { Icon, Label } from '@atlas/ui';

const ErrorField = ({ field }) => {
  const fieldName = useLabel(field.replace('_', ' ')).replaceAll(
    /(\[(?<link>[^\]]+)\]\([^)]+\))/g,
    '$<link>',
  );
  return (
    <li className="signup-error-list-item" key={field}>
      {fieldName}
    </li>
  );
};

const ErrorFields = ({ errorFields, shouldScroll }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (shouldScroll) {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [shouldScroll]);

  if (errorFields.length === 0) {
    return null;
  }

  return (
    <div className="signup-error-wrapper" ref={ref}>
      <div className="notification-item-icon">
        <Icon className="icon-error" name="error" />
      </div>
      <div className="signup-error-list-wrapper">
        <Label className="signup-error-list-header" message="registration_failed_signup_errors" />
        <ul className="signup-error-list">
          {errorFields.map(field => (
            <ErrorField field={field} key={field} />
          ))}
        </ul>
      </div>
    </div>
  );
};

ErrorFields.propTypes = {
  errorFields: PropTypes.arrayOf(PropTypes.string).isRequired,
  field: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
  shouldScroll: PropTypes.bool,
};

export default ErrorFields;
